import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"

const Pager = ({ pageContext }) => {
  const { previousPagePath, nextPagePath } = pageContext

  return (
    <div className="container text-center">
      {previousPagePath && (
        <div className="col">
          <Link to={previousPagePath} className="pager-text">Previous</Link>
        </div>
      )}
      {nextPagePath && (
        <div className="col">
          <Link to={nextPagePath} className="pager-text">Next</Link>
        </div>
      )}
    </div>
  )
}

Pager.propTypes = {
  pageContext: PropTypes.object.isRequired
}

export default Pager